// extracted by mini-css-extract-plugin
export default {"column":"recommendation-panel_column__IvGGs","recommendation":"recommendation-panel_recommendation__PuQ-1","empty":"recommendation-panel_empty__lbg6-"};